import React, { useState, useEffect } from 'react';
import Navbar from '../../../ReusableBlocks/Navbar';
import Footer from '../../../ReusableBlocks/FooterBlock';
import LoadingScreen from '../../../ReusableBlocks/LoadingScreen';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import * as PATH from '../../../CentralisedLink'

const FAQ_Page_Quest = () => {
    
    return (
        <>
            <Navbar />
            <div className='FAQ-PAGE-BACKGROUDN'>
                <div className='container'>
                    <br />
                    <div className='faq-section'>
                        <center>
                            <div className='faq-header'>
                                <h1 className='freq-titile'>Frequently asked questions</h1>
                            </div>
                        </center>
                        <div className='faq-body'>
                            <h2 className='faq-question'>What is the question?</h2>
                            <p className='faq-answer'>
                                This is where the detailed answer to the FAQ question will be displayed. It can be as long or short as necessary to fully address the question. Additional information, links, or resources can also be included here.
                            </p>
                            <Link to={`${PATH.FAQ_PATH}`}>
                            <button className='reset-btn-cancel'><i className="fa-solid fa-chevron-left"></i> Back to FAQs</button>
                            </Link>
                        </div>
                    </div>
                    <br />
                </div>
            </div>
            <Footer />
        </>
    )
}

export default FAQ_Page_Quest